<template>
    <div class="grid ls-block">
        <!-- block element to prevent grid from flowing out of container on IE -->
        <div class="grid__col-12">
            <div class="view-other-services__button-row">
                <label
                    v-ls-track.click="{
                        target: 'view-other-services-drawer--toggle',
                    }"
                    for="other-services-drawer"
                    :class="{ 'ls-button--block': screenSize.xs }"
                    @click.prevent="toggleDrawer()"
                >
                    <input
                        id="other-services-drawer"
                        v-model="showOtherServicesDrawer"
                        type="checkbox"
                    />
                    <branded-checkbox :is-active="showOtherServicesDrawer" :is-big-icon="true" />
                    <span data-font-size="-1">
                        I'm interested in
                        <span class="ls-nowrap"
                            >additional lawn services<!--
                     --><i
                                class="fa fa-lg ls-color--gray--mid"
                                :class="{
                                    'fa-caret-up': showOtherServicesDrawer,
                                    'fa-caret-down': !showOtherServicesDrawer,
                                }"
                            ></i
                        ></span>
                    </span>
                </label>
            </div>
        </div>
        <div v-if="showOtherServicesDrawer">
            <ls-view-other-services-drawer></ls-view-other-services-drawer>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import lsViewOtherServicesDrawer from '@/components/original-mydot/view-other-services/ViewOtherServicesDrawer.vue';
import brandedCheckbox from '@/components/original-mydot/branded-checkbox/BrandedCheckbox.vue';
import brandMixin from '@/mixins/brand.mixin';

export default {
    components: {
        brandedCheckbox,
        lsViewOtherServicesDrawer,
    },
    mixins: [brandMixin],
    data() {
        return {
            showOtherServicesDrawer: false,
        };
    },
    computed: {
        ...mapState(['screenSize']),
    },
    methods: {
        toggleDrawer() {
            this.showOtherServicesDrawer = !this.showOtherServicesDrawer;
        },
    },
};
</script>

<style lang="scss">
.view-other-services__button-row {
    margin-top: rem(2);
    margin-bottom: rem(-3);

    label {
        display: flex;
        align-items: center;
        user-select: none;
        cursor: pointer;

        input {
            display: none;
        }

        i {
            margin: 0 rem(-5);
        }
    }
}
.themed-lawnlove {
    .view-other-services__button-row {
        span {
            line-height: 1;
        }

        .branded-checkbox {
            display: inline-flex;
        }
    }
}
</style>
